import { Link } from "react-router-dom";
import { mediaItems } from "@/mocks/media";
import MediaCard from "@/components/feature/MediaCard";

export default function HotPicks() {
  const hot = [...mediaItems].sort((a, b) => b.hot - a.hot).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 mt-14">
      <div className="flex items-end justify-between gap-4">
        <div>
          <h2 className="text-xl font-bold text-foreground-950 font-heading md:text-2xl">
            热门影视推荐
          </h2>
          <p className="mt-1 text-sm text-foreground-500">
            根据热度与人气精选，值得一看的好作品
          </p>
        </div>
        <div className="hidden items-center gap-2 sm:flex">
          <Link
            to="/category/电视剧"
            className="whitespace-nowrap rounded-md bg-secondary-100 px-3.5 py-1.5 text-sm font-medium text-secondary-900 hover:bg-secondary-200 transition-colors cursor-pointer"
          >
            更多电视剧
          </Link>
          <Link
            to="/category/电影"
            className="whitespace-nowrap rounded-md bg-secondary-100 px-3.5 py-1.5 text-sm font-medium text-secondary-900 hover:bg-secondary-200 transition-colors cursor-pointer"
          >
            更多电影
          </Link>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {hot.map((item, index) => (
          <MediaCard key={item.id} item={item} index={index} />
        ))}
      </div>
    </section>
  );
}